/*
* PaymentButton figures out which payment button to display and returns it.
* if they do not have a subscription then show "sign me up" on the 2 buttons
* If they have a subscription, figure out when to show "Downgrade" or "Current Plan" or "Upgrade"
* Do this by passing in what is currently selected for recurring and number of students.
* Build the paymentPlan string for the two buttons based on what is selected, then compare that too the user's selected plan
*
*/

import * as React from 'react';
import { Button } from 'react-bootstrap';

interface Props extends React.Props<PaymentButton> {
  planChange: {
    isNew: boolean,
    isCurrent: boolean,
    isUpgrade: boolean,
    isDowngrade: boolean,
  }
  handleClick: any;
  loading: boolean;
}

class PaymentButton extends React.Component<Props, {}> {
  buttonLabelText = (): { hasButton: boolean, label: string } => {
    if (this.props.planChange.isCurrent) {
      return { hasButton: false, label: 'Current Plan' };
    }

    if (this.props.planChange.isUpgrade) {
      return { hasButton: true, label: 'Upgrade' };
    }

    if (this.props.planChange.isDowngrade) {
      return { hasButton: true, label: 'Downgrade' };
    }

    return { hasButton: true, label: 'Sign Me Up!' };
  }

  render() {
    const button = this.buttonLabelText();

    if (! button.hasButton) {
      return (
        <div>
          <h4><strong>{button.label}</strong></h4>
        </div>
      );
    }

    return (
      <div>
        <Button
          className={button.label}
          onClick={() => this.props.handleClick()}
          disabled={this.props.loading}
        >
          {button.label}
        </Button>
      </div>
    );
  }
}

export default PaymentButton;
